import { render, staticRenderFns } from "./CarisLicenseNewHeader.vue?vue&type=template&id=15745b26&scoped=true"
import script from "./CarisLicenseNewHeader.vue?vue&type=script&lang=js"
export * from "./CarisLicenseNewHeader.vue?vue&type=script&lang=js"
import style0 from "./CarisLicenseNewHeader.vue?vue&type=style&index=0&id=15745b26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15745b26",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fcaris-license-new-header%2FCarisLicenseNewHeader.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports